
import md5 from 'js-md5';
import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getUserGravatar = (email) => {
  return `https://www.gravatar.com/avatar/${md5(email)}.jpg?d=identicon`
}


export const selectCurrentUser = (state) => state.currentUser


export const currentUserSelector = createSelector(
  selectCurrentUser,
  (currentUser) => currentUser && {...currentUser, avatar:getUserGravatar(currentUser.email)}
)


export const currentCustomerSubscriptionPlanSelector = (state) => {
  const currentUser = currentUserSelector(state);
  return currentUser && currentUser.account && get(currentUser.account, 'subscriptions_info[0].plan');
};


export const currentCustomerSubscriptionPlanRawIdSelector =  createSelector(
  currentCustomerSubscriptionPlanSelector,
  (currentPlan) => currentPlan && (currentPlan.id || '').replace(/_(annual|monthly)/, '').replace(/2019/, '')
)


export const currentCustomerInfoSelector = (state) => {
  const currentUser = currentUserSelector(state);
  return currentUser && currentUser.account && get(currentUser.account, 'customer_info');
};


// WEBPACK FOOTER //
// ./src/reducers/selectors/user.js